import axios from "./axiosConfig";
import authHeader from "./auth-header";
import { API_URL } from "utils/constants";

const getSubdomain = (subdomain) => {
// !!!!for master use this
 return axios.get(
  API_URL.replace(".api", "api") + `customers/subdomain_exists/${subdomain}`,
);
  
// !!!!for dev use this
// return axios.get(
//     API_URL + `customers/subdomain_exists/${subdomain}`,
//   );
};

const getCustomisation = () => {
  return axios.get(API_URL + "customers/customization/", { headers: authHeader() });
};

const getUserRole = () => {
  return axios.get(API_URL + "users/role/", { headers: authHeader() });
};

/* Reset Password */
const resetPassword = (email) => {
  return axios.post(API_URL + "auth/users/reset_password/", {
    email,
  });
};

/* Reset Password Confirm */
const resetPasswordConfirm = (uid, token, password) => {
  return axios.post(API_URL + "auth/users/reset_password_confirm/", {
    uid,
    token,
    new_password: password,
  });
};

/* filter */
const getTeamMembersList = (activeOnly, directEmployeesOnly) => {
  return axios.get(API_URL + "employees/photos", {
    params: {
      active_only: activeOnly ?? 1,
      direct_employees_only: directEmployeesOnly ?? 1,
    },
    headers: authHeader(),
  });
};
const getTeamMembersListOddo = (activeOnly, directEmployeesOnly, originUrl, token) => {
  return axios.get(`${originUrl}/report/calls-and-tracking/team-members/`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      active_only: activeOnly,
      direct_employees_only: directEmployeesOnly,
    },
  });
};

/* Report pages */
const getReport = (requestPath, dateFrom, dateTo, employeesList) => {
  return axios.get(API_URL + requestPath, {
    params: {
      date_from: dateFrom,
      date_to: dateTo,
      employees_list: employeesList,
    },
    headers: authHeader(),
  });
};
const getReportOddo = (dateFrom, dateTo, employeesList, originUrl, token, paginationOddo) => {
  return axios.get(`${originUrl}/report/calls-and-tracking/data/`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      date_from: dateFrom,
      date_to: dateTo,
      employee_list: employeesList,
      limit: paginationOddo.limit,
      offset: paginationOddo.offset,
    },
  });
};

/* Update data page */
const getExtensionStatus = () => {
  return axios.get(API_URL + "parsers/extension_calls/status", {
    headers: authHeader(),
  });
};

const getTimetrackingStatus = (month) => {
  return axios.get(API_URL + "parsers/timetracking/status/", {
    params: {
      month,
    },
    headers: authHeader(),
  });
};

const runParser = (requestPath, month) => {
  return axios.get(API_URL + requestPath, {
    params: month
      ? {
          month,
        }
      : "",
    headers: authHeader(),
  });
};

/* Working hours Popup */
const getPopupData = (requestPath, date, employeeId) => {
  return axios.get(API_URL + requestPath, {
    params: {
      date,
      employee_id: employeeId,
    },
    headers: authHeader(),
  });
};

/* Calls & Tracking Popup */
const getPopupDetails = (gmailId) => {
  return axios.get(API_URL + `emails/${gmailId}`, { headers: authHeader() });
};

/* Schadules Page */
const getSchedulesList = () => {
  return axios.get(API_URL + "profile/schedules/", {
    headers: authHeader(),
  });
};

const getWorkTimeForecasting = async () => {
  const { data } = await axios.get(API_URL + "profile/work_time_forecastings/", {
    headers: authHeader(),
  });
  return data;
};

const getBreaks = async () => {
  const { data } = await axios.get(API_URL + "profile/breaks/", {
    headers: authHeader(),
  });
  return data;
};

const checkGmailAccess = () => {
  return axios.get(API_URL + "check_gmail_access/", { headers: authHeader() });
};

const getUserTimezone = () => {
  return axios.get(API_URL + "profile/timezone/", { headers: authHeader() });
};

const userService = {
  getSubdomain,
  getUserRole,
  resetPassword,
  resetPasswordConfirm,
  getTeamMembersList,
  getTeamMembersListOddo,
  getReport,
  getReportOddo,
  getExtensionStatus,
  getTimetrackingStatus,
  runParser,
  getPopupData,
  getPopupDetails,
  getSchedulesList,
  getWorkTimeForecasting,
  getBreaks,
  getCustomisation,
  checkGmailAccess,
  getUserTimezone,
};

export default userService;
